import { PAYEX_URL } from 'constants/config';
import type { User } from 'models/user';
import { fetchJson, fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

import type {
  EmailLookupLastPaymentResponse,
  EmailLookupResponse,
  UpdateUserPayload,
} from './types';

export const users = {
  updateUser: (payload: UpdateUserPayload) => {
    const path = `${PAYEX_URL}/users`;
    const body = JSON.stringify(payload);

    const options = {
      method: 'PATCH',
      body,
    };

    return fetchWithAuthentication<
      Pick<User, 'firstName' | 'lastName' | 'email'>
    >(path, options);
  },

  emailLookup: ({ email }: { email: string }) => {
    const path = `${PAYEX_URL}/users/email_lookup`;
    return fetchJson<EmailLookupResponse>(path, {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  emailLookupLastPayment: ({ email }: { email: string }) => {
    const path = `${PAYEX_URL}/users/email_lookup/last_payment`;
    return fetchWithAuthentication<EmailLookupLastPaymentResponse>(path, {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },
};
